var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin OH
 * @contact hjoh@detech.co.kr
 * @date 2023-09-13
 * @brief SEI 운영관리 -SiteInfoView 개발
 *
 ********************************************************************/
import { useEffect, useState } from "react";
import { useAsync } from "react-async";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { adminTypeState, alertState, curAdminTreeState } from "../../../../../recoil/assessmentState";
import { reLoad, reLoadPage, userInfoLoginState } from "../../../../../recoil/userState";
// utils
import { langId } from "../../../../../recoil/langState";
import { loadingBoxState } from "../../../../../recoil/menuState";
import * as CONST from "../../../../../utils/Const";
import * as HTTPUTIL from "../../../../../utils/api/HttpUtil";
import * as CUTIL from "../../../../../utils/commUtils";
import { useTrans } from "../../../../../utils/langs/useTrans";
import EhpPostCode from "../../../../common/postcode/EhpPostCode";
function SiteSubZone(props) {
    const t = useTrans();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [recoilTree, setRecoilTree] = useRecoilState(curAdminTreeState);
    const reload = useRecoilValue(reLoad);
    const setRecoilType = useSetRecoilState(adminTypeState);
    const langIds = useRecoilValue(langId);
    // props
    const { handleOpenPop, onClickTab, isMobile } = props;
    const [subZoneInfo, setSubZoneInfo] = useState(null);
    const [subZoneItem, setSubZoneItem] = useState(null);
    const [subZnoeAddress, setsubZoneAddress] = useState(null);
    const [isPopupPostCode, setIsPopupPostCode] = useState(false);
    useEffect(() => {
        // 등록
        handleOpenPop("pop-add-detail", _jsx(RoomAddpop, { htmlClose: _jsxs(_Fragment, { children: [_jsx("h1", { children: t("라벨.신규추가") }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => CUTIL.jsclose_Popup("pop-add-detail") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] }) }));
        //상세사업장 수정
        handleOpenPop("pop-add-detail-edit", _jsx(SubZoneEditpop, { subZoneItem: subZoneItem, setsubZoneAddress: setsubZoneAddress, subZnoeAddress: subZnoeAddress, setIsPopupPostCode: setIsPopupPostCode, htmlClose: _jsxs(_Fragment, { children: [_jsx("h1", { children: t("라벨.수정") }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => CUTIL.jsclose_Popup("pop-add-detail-edit") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] }) }));
        // 삭제
        handleOpenPop("pop-delete", _jsx(DeletePop, {}));
        //
        handleOpenPop("pop-postcode", _jsx(EhpPostCode, { isPopup: isPopupPostCode, setIsPopup: setIsPopupPostCode, setAddress: callbackSetZoneInfoAddress }));
    }, [subZoneItem, subZnoeAddress, isPopupPostCode]);
    // 기본 주소
    let appPath = `?subZoneId=${recoilTree.subZone.subZoneId}`;
    // 상세 사업장 API
    const { data: data, isLoading } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/product/subzone/detail${appPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: appPath + reload + langIds,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setSubZoneInfo(data.body);
            }
        }
    }, [data, reload, langIds]);
    function Edit(e) {
        setSubZoneItem(subZoneInfo);
        setsubZoneAddress(subZoneInfo.addressId
            ? {
                address: subZoneInfo.address,
            }
            : null);
        CUTIL.jsopen_Popup(e);
    }
    function callbackSetZoneInfoAddress(val) {
        setsubZoneAddress(val);
    }
    function RoomGo(item) {
        setRecoilTree(Object.assign(Object.assign({}, recoilTree), { room: {
                roomId: item.roomId,
                roomName: item.roomName,
            } }));
        setRecoilType("room");
        onClickTab("DEVICE");
        let zone_class = document.querySelector(".add");
        zone_class.classList.add("nobg");
        let subzone_class = document.querySelector(".szadd");
        subzone_class.classList.add("nobg");
    }
    return (_jsx(_Fragment, { children: subZoneInfo && (_jsxs("div", Object.assign({ className: "box__body", style: { paddingTop: isMobile ? "59px" : "24px" } }, { children: [_jsx("div", Object.assign({ className: "tbl__top" }, { children: _jsx("div", Object.assign({ className: "right" }, { children: _jsxs("div", Object.assign({ className: "top-button" }, { children: [_jsx("button", Object.assign({ type: "button", className: "btn btn-edit blue js-open", "data-pop": "pop-add-detail-edit", onClick: (e) => Edit(e) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC218\uC815" })) })), _jsx("button", Object.assign({ type: "button", className: "btn btn-delete blue js-open", "data-pop": "pop-delete", onClick: (e) => CUTIL.jsopen_Popup(e) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C" })) }))] })) })) })), _jsxs("div", Object.assign({ className: "content__info" }, { children: [_jsx("h3", Object.assign({ className: "hide" }, { children: "\uC0C1\uC138\uC0AC\uC5C5\uC7A5 \uC815\uBCF4" })), _jsxs("ul", Object.assign({ className: "form__info" }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit w120" }, { children: t("라벨.상세사업장명") })), _jsx("p", Object.assign({ className: "txt" }, { children: subZoneInfo.subZoneName }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit w120" }, { children: t("라벨.상세사업장주소") })), _jsx("p", Object.assign({ className: "txt" }, { children: subZoneInfo.address }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit w120" }, { children: t("라벨.메모") })), _jsx("p", Object.assign({ className: "txt" }, { children: !subZoneInfo.memo ? "-" : subZoneInfo.memo }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit w120" }, { children: t("라벨.운영설비") })), _jsxs("p", Object.assign({ className: "txt" }, { children: [subZoneInfo.itemCount, " ea"] }))] })] }))] })), _jsxs("div", Object.assign({ className: "content__info line" }, { children: [_jsx("div", Object.assign({ className: "top" }, { children: _jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.분전소현황") })) })), _jsxs("ul", Object.assign({ className: "box-small-wrap link" }, { children: [subZoneInfo.roomDto.map((item, idx) => (_jsxs("li", Object.assign({ onClick: (e) => RoomGo(item), style: { cursor: "pointer" } }, { children: [_jsx("p", Object.assign({ className: "tit" }, { children: item.roomName })), _jsx("p", Object.assign({ className: "count-info" }, { children: _jsxs("span", { children: [_jsx("strong", { children: item.itemCount }), "ea"] }) }))] }), "roomDto" + idx.toString()))), _jsx("li", { children: _jsx("button", Object.assign({ type: "button", className: "btn-add js-open", "data-pop": "pop-add-detail", onClick: (e) => CUTIL.jsopen_Popup(e) }, { children: _jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.분전소추가") })) })) })] }))] }))] }))) }));
}
export default SiteSubZone;
function RoomAddpop(props) {
    const t = useTrans();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [recoilTree, setRecoilTree] = useRecoilState(curAdminTreeState);
    const [alert, setAlert] = useRecoilState(alertState);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    const [reload, setReload] = useRecoilState(reLoad);
    const [reloadPages, setReloadPages] = useRecoilState(reLoadPage);
    //
    const [errorList, setErrorList] = useState([]);
    const [roomName, setRoomName] = useState("");
    const [memo, setMemo] = useState("");
    const [file, setFile] = useState([]);
    const lastNum = 10;
    function onChangeRoom(e) {
        setRoomName(e.target.value);
    }
    // 첨부파일 저장
    function saveFileImage(e) {
        return __awaiter(this, void 0, void 0, function* () {
            const files = e.target.files;
            let imageUpload = [...file];
            for (let i = 0; i < files.length; i++) {
                //  미리보기 구현시 필요 URL.createObjectURL(file[i]);
                imageUpload.push(files[i]);
            }
            if (imageUpload.length > lastNum) {
                imageUpload = imageUpload.slice(0, 10);
                setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "첨부파일은 10개 까지 가능합니다." }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
            }
            setFile(imageUpload);
            e.target.value = ""; // file name 초기화
        });
    }
    // 이미지 삭제
    function onClickAttachFileDelete(index) {
        setFile(file.filter((_, idx) => idx !== index));
    }
    function RoomAdd(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POST",
                appPath: `/product/room`,
                appQuery: {
                    subZoneId: recoilTree.subZone.subZoneId,
                    roomName: roomName,
                    memo: memo,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    if (file.length > 0) {
                        uploadFileImage(data.body.roomId);
                    }
                    else {
                        setReloadPages(true);
                        setReload(true);
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: t("라벨.분전소가등록되었습니다") }));
                        CUTIL.jsclose_Popup("pop-add-detail");
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                        setReload(false);
                        setReloadPages(false);
                        setRecoilIsLoadingBox(false);
                    }
                }
                else {
                    // need error handle
                    if (data.errorList !== null) {
                        setErrorList(data.errorList);
                    }
                    else {
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: CONST.ERROR_MSG }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    }
                    setRecoilIsLoadingBox(false);
                }
            }
        });
    }
    setErrorList;
    // 첨부파일 업로드
    function uploadFileImage(roomId) {
        return __awaiter(this, void 0, void 0, function* () {
            setRecoilIsLoadingBox(true);
            let appPath = `?roomId=${roomId}`;
            const formData = new FormData();
            // 파일 데이터 저장
            file.map((files) => formData.append("files", files));
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POSTF",
                appPath: `/images/room${appPath}`,
                appQuery: formData,
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReloadPages(true);
                    setReload(true);
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: t("라벨.분전소가등록되었습니다") }));
                    CUTIL.jsclose_Popup("pop-add-detail");
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setReload(false);
                    setReloadPages(false);
                    setRecoilIsLoadingBox(false);
                }
                else {
                    // need error handle
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: CONST.POP_RELOAD, type: CONST.TYPE_NONE, divTag: "오류로 인하여 첨부파일이 제거되어 분전소만 등록되었습니다." }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setRecoilIsLoadingBox(false);
                }
            }
        });
    }
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: "popup__body" }, { children: [_jsxs("ul", Object.assign({ className: "locate" }, { children: [_jsx("li", { children: recoilTree.zone.zoneName }), _jsx("li", { children: recoilTree.subZone.subZoneName }), _jsx("li", { children: t("라벨.전체") })] })), _jsx("h2", Object.assign({ className: "mt-32" }, { children: t("라벨.신규분전소등록") })), _jsxs("ul", Object.assign({ className: "form__input" }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.명칭") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", placeholder: t("라벨.분전소입력"), value: roomName, onChange: (e) => onChangeRoom(e) }) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.전기실도면") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsxs("div", Object.assign({ className: "filebox" }, { children: [_jsx("input", { className: "upload-name", value: "", placeholder: t("라벨.클릭등록"), readOnly: true }), _jsx("label", Object.assign({ htmlFor: "file" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uD30C\uC77C\uCC3E\uAE30" })) })), _jsx("input", { type: "file", id: "file", multiple: true, onChange: (e) => saveFileImage(e) })] })), _jsx("p", Object.assign({ className: "txt-info" }, { children: t("라벨.첨부120MB") })), _jsx("ul", Object.assign({ className: "filelist" }, { children: file.map((img, idx) => (_jsxs("li", { children: [_jsx("span", { children: img.name }), _jsx("button", Object.assign({ type: "button", className: "btn btn-delete", onClick: (e) => onClickAttachFileDelete(idx) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C" })) }))] }, "imgsEdit_" + idx.toString()))) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.메모") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("textarea", { className: "h74", placeholder: t("라벨.텍스트입력"), value: memo, onChange: (e) => setMemo(e.target.value) }) }))] })] }))] })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => CUTIL.jsclose_Popup("pop-add-detail") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => RoomAdd(e) }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] }));
}
function SubZoneEditpop(props) {
    const t = useTrans();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [recoilTree, setRecoilTree] = useRecoilState(curAdminTreeState);
    const [alert, setAlert] = useRecoilState(alertState);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    const [reload, setReload] = useRecoilState(reLoad);
    const [reloadPages, setReloadPages] = useRecoilState(reLoadPage);
    //props
    const { subZnoeAddress, setIsPopupPostCode, resetPop, setResetPop, setsubZoneAddress, subZoneItem } = props;
    //
    const [errorList, setErrorList] = useState([]);
    const [subZoneName, setSubZoenName] = useState("");
    const [memo, setMemo] = useState("");
    useEffect(() => {
        if (subZoneItem) {
            setSubZoenName(subZoneItem.subZoneName ? subZoneItem.subZoneName : "");
            setMemo(subZoneItem.memo ? subZoneItem.memo : "");
            setErrorList([]);
        }
        if (resetPop) {
            Close("pop-add-detail");
        }
        if (subZnoeAddress) {
            setErrorList(errorList.filter((err) => err.field !== "address"));
        }
    }, [resetPop, subZoneItem, subZnoeAddress]);
    function onChangeSubZone(e) {
        setSubZoenName(e.target.value);
    }
    function SubZoneAdd(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            if (subZnoeAddress == null) {
                setErrorList([subZnoeAddress == null && { field: "address", msg: t("라벨.필수항목을입력하지않으셨습니다") }]);
            }
            else {
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "PUT",
                    appPath: `/product/subzone/${recoilTree.subZone.subZoneId}`,
                    appQuery: {
                        subZoneName: subZoneName,
                        address: subZnoeAddress.address,
                        memo: memo,
                    },
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        if (!subZoneItem.addressId) {
                            SubZoneAddressAdd(data.body);
                        }
                        else {
                            SubZoneAddressEidt(data.body);
                        }
                    }
                    else {
                        // need error handle
                        if (data.errorList !== null) {
                            setErrorList(data.errorList);
                        }
                        else {
                            Close("pop-add-detail-edit");
                            setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: CONST.ERROR_MSG, callBack: () => {
                                    CUTIL.jsclose_Popup(CONST.POP_ALERT);
                                } }));
                            CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                        }
                        setRecoilIsLoadingBox(false);
                    }
                }
            }
        });
    }
    function SubZoneAddressAdd(subZone) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POST",
                appPath: `/energyreport/address`,
                appQuery: {
                    address: subZnoeAddress.address,
                    sigunguCd: subZnoeAddress.sigunguCd,
                    bjdongCd: subZnoeAddress.bjdongCd,
                    bun: subZnoeAddress.bun,
                    ji: subZnoeAddress.ji,
                    postalCode: subZnoeAddress.postalCode,
                    bname: subZnoeAddress.bname,
                    subZoneId: subZone.subZoneId,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    Close("pop-add-detail-edit");
                    setReloadPages(true);
                    setReload(true);
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: t("라벨.수정되었습니다"), callBack: () => {
                            setReload(false);
                            setReloadPages(false);
                            CUTIL.jsclose_Popup(CONST.POP_ALERT);
                        } }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setRecoilIsLoadingBox(false);
                }
                else {
                    // need error handle
                    setErrorList(data.errorList);
                    setReloadPages(true);
                    setReload(true);
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: t("라벨.상세사업장의주소를다시입력해주세요") }));
                    Close("pop-add-detail-edit");
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setReload(false);
                    setReloadPages(false);
                    setRecoilIsLoadingBox(false);
                    setRecoilIsLoadingBox(false);
                }
            }
        });
    }
    function SubZoneAddressEidt(subZone) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/energyreport/address/${subZoneItem.addressId}`,
                appQuery: {
                    address: subZnoeAddress.address,
                    sigunguCd: subZnoeAddress.sigunguCd,
                    bjdongCd: subZnoeAddress.bjdongCd,
                    bun: subZnoeAddress.bun,
                    ji: subZnoeAddress.ji,
                    postalCode: subZnoeAddress.postalCode,
                    bname: subZnoeAddress.bname,
                    subZoneId: subZone.subZoneId,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    Close("pop-add-detail-edit");
                    setReloadPages(true);
                    setReload(true);
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: t("라벨.수정되었습니다"), callBack: () => {
                            setReload(false);
                            setReloadPages(false);
                            CUTIL.jsclose_Popup(CONST.POP_ALERT);
                        } }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setRecoilIsLoadingBox(false);
                }
                else {
                    // need error handle
                    Close("pop-add-detail-edit");
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.errorList !== null ? data.errorList.map((err) => err.msg) : "500 Internal Server Error" }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setRecoilIsLoadingBox(false);
                }
            }
        });
    }
    function onClickPostCode(e) {
        setIsPopupPostCode(true);
        CUTIL.jsopen_InteriorPopup(e);
    }
    /*
      function KeyDowns(e) {
          if (memo.length > 0) {
              if (e.key == "Enter") {
                  let hashTagTxt = `# ${memo}`
                  setHashTag([...hashTag, hashTagTxt])
              }
          }
      }
      function KeyUps(e) {
          if (memo.length > 0) {
              if (e.key == "Enter") {
                  setMemo("")
              }
          }
      } */
    function Close(id) {
        setsubZoneAddress(null);
        setErrorList([]);
        // setResetPop(false)
        CUTIL.jsclose_Popup(id);
    }
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: "popup__body" }, { children: [_jsx("ul", Object.assign({ className: "locate" }, { children: _jsx("li", { children: recoilTree.zone.zoneName }) })), _jsx("h2", Object.assign({ className: "mt-32" }, { children: t("라벨.신규상세사업장정보") })), _jsxs("ul", Object.assign({ className: "form__input" }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.명칭") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { className: `${errorList.filter((err) => err.field === "subZoneName").length > 0 ? " input-error" : ""}`, type: "text", value: subZoneName, placeholder: t("라벨.상세사업장입력"), onChange: (e) => onChangeSubZone(e) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "subZoneName").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.상세사업장주소") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsxs("div", Object.assign({ className: "txt" }, { children: [_jsxs("div", Object.assign({ className: "box__search" }, { children: [_jsx("input", { className: `js-open ${errorList.filter((err) => err.field === "address").length > 0 ? " input-error" : ""}`, type: "text", style: { background: "#fff" }, placeholder: t("라벨.주소선택"), "data-pop": "pop-postcode", onFocus: (e) => onClickPostCode(e), value: subZnoeAddress ? subZnoeAddress.address || "" : "", readOnly: true }), _jsx("button", Object.assign({ type: "button", className: "btn btn-search js-open", "data-pop": "pop-postcode", onClick: (e) => onClickPostCode(e) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC870\uD68C" })) }))] })), _jsx("p", Object.assign({ className: "input-errortxt", style: { display: errorList.filter((err) => err.field === "address").length > 0 ? "block" : "none" } }, { children: errorList.filter((err) => err.field === "address").map((err) => err.msg) }))] })) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.메모") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("textarea", { className: "h74", placeholder: t("라벨.텍스트입력"), value: memo, onChange: (e) => setMemo(e.target.value) }) }))] })] }))] })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => Close("pop-add-detail") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => SubZoneAdd(e) }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] }));
}
function DeletePop(props) {
    const t = useTrans();
    // recoli
    const userInfo = useRecoilValue(userInfoLoginState);
    const [recoilTree, setRecoilTree] = useRecoilState(curAdminTreeState);
    const setReload = useSetRecoilState(reLoad);
    const [alert, setAlert] = useRecoilState(alertState);
    // props
    const { checkArr, setCheckArr } = props;
    function Delete(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "DELETE",
                appPath: `/product/usertree?productId=${recoilTree.subZone.subZoneId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    CUTIL.jsclose_Popup("pop-delete");
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: CONST.POP_RELOAD, type: CONST.TYPE_NONE, divTag: t("라벨.삭제되었습니다") }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
                else {
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: data.errorList !== null ? data.errorList.map((err) => err.msg) : CONST.ERROR_MSG }));
                    CUTIL.jsclose_Popup("pop-delete");
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("p", { children: t("라벨.상세사업장을삭제하시겠습니까") }) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => CUTIL.jsclose_Popup("pop-delete") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => {
                            Delete(e);
                        } }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] }));
}
